module.exports = __webpack_public_path__ + "static/media/hartfordLogo.22e1238e.png";